import { useState } from "react";
import { Loader2 } from "lucide-react";
import { MaskLines } from "../components/site/Reveal";
import { PostCard } from "../components/news/PostCard";
import { CATEGORIES, usePosts } from "../lib/posts";
import { useTitle } from "../lib/useTitle";

export default function News() {
  useTitle("News & Insights | Gait Naurish Ltd.");
  const [cat, setCat] = useState("");
  const posts = usePosts(cat);
  const [first, ...rest] = posts || [];

  return (
    <main data-testid="news-page">
      <section className="bg-[var(--forest)] pt-40 md:pt-48 pb-16 md:pb-20">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <p className="text-[13px] font-bold uppercase tracking-[0.2em] text-[var(--lime)]">News &amp; insights</p>
          <MaskLines testId="news-heading" className="font-display text-white text-4xl sm:text-6xl lg:text-7xl leading-[1.02] mt-5" lines={["Trial results, events", "and technical know-how."]} />
        </div>
      </section>
      <section className="mx-auto max-w-[1400px] px-5 md:px-10 py-14 md:py-20">
        <div className="flex gap-2 overflow-x-auto pb-2 -mx-5 px-5 md:mx-0 md:px-0">
          {["", ...CATEGORIES].map((c) => (
            <button key={c || "all"} data-testid={`news-filter-${(c || "all").split(" ")[0].toLowerCase()}`} onClick={() => setCat(c)} className={`shrink-0 rounded-md border px-4 py-2.5 text-sm font-semibold transition-colors ${cat === c ? "bg-[var(--forest)] text-white border-[var(--forest)]" : "border-[var(--line)] hover:border-[var(--forest)]"}`}>
              {c || "All"}
            </button>
          ))}
        </div>
        <div className="mt-10">
          {posts === null && <Loader2 className="animate-spin text-[var(--moss)]" />}
          {posts && posts.length === 0 && <p data-testid="news-empty" className="text-[var(--muted)] py-16">No articles in this category yet — check back soon.</p>}
          {first && <PostCard p={first} large />}
          {rest.length > 0 && (
            <div className="mt-5 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {rest.map((p, i) => <PostCard key={p.id} p={p} i={i} />)}
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
